import React from "react";
import Image from "next/image";
import MbbsForm from "@/components/forms/MbbsForm";

const DoctorBannerDesktop = () => {
  const scrollToSection = (sectionId: string) => {
    const section = document.getElementById(sectionId);
    let yOffset = window.innerWidth <= 768 ? -100 : -150;
    if (section) {
      const yPosition =
        section.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: yPosition, behavior: "smooth" });
    }
  };

  return (
    <div className="w-full bg-[#061A2F]">
      <div className="relative overflow-visible bg-[url('/cpa/visit/newVisit/ban_bgn.png')] bg-no-repeat bg-right bg-cover -mt-2 mx-auto w-full 2xl:h-[600px] md:h-[600px] xl:px-0 md:px-6 lg:!px-6 relative md:pb-0 block">
        <div className="lg:container h-full mx-auto 2xl:px-0 xl:px-10 lg:p-0 text-[#030F1C] z-50 relative">
          {/* LCP candidate - ensure this is visible early and prioritized */}
          <Image
            src="/cpa/visit/newVisit/uni.png"
            alt="Special Offer University"
            className="absolute bottom-[-14.9%] right-[50%] translate-x-[50%] z-20"
            width={410}
            height={129}
            priority
            sizes="(max-width: 768px) 100vw, 410px"
          />

          <div
            className="absolute bottom-[-14.3%] right-[49.5%] translate-x-[50%] z-30 cursor-pointer"
            onClick={() => scrollToSection("acc")}
          >
            <Image
              src="/cpa/visit/newVisit/circ.png"
              alt="Special Offer Button"
              width={176}
              height={129}
              priority
              sizes="(max-width: 768px) 100vw, 176px"
            />
            <div>
              <span className="m_scroll_arrows doi"></span>
              <span className="m_scroll_arrows trei"></span>
            </div>
            <div className="absolute bottom-[35%] right-[40%] translate-[-50%, -50%] mt-[30px] flex flex-col items-center space-y-2">
              <div className="flex flex-col items-center">
                <div className="w-8 h-8 border-b-[4px] border-r-4 border-[#FFBA08] transform rotate-45 animate-slide relative top-3" />
                <div className="w-8 h-8 border-b-[4px] border-r-4 border-[#FFBA08] transform rotate-45 animate-slide" />
              </div>
            </div>
          </div>

          <div className="flex justify-between items-center relative 2xl:top-[40px] md:top-[40px] mx-auto">
            <div className="md:relative md:w-[51%] md:mt-5 mt-7">
              <p className="text-[26px] text-white font-medium leading-[1.2] mb-4">
                Scored 144+ in <span className="text-[#FFBA08]">NEET UG?</span>
              </p>
              <h1 className="2xl:text-[48px] md:text-[42px] font-bold md:leading-[1] text-white">
                Study MBBS-MD in America
              </h1>
              <h2 className="2xl:text-[48px] md:text-[40px] font-bold md:leading-[1] text-[#FFBA08]">
                Be a Licensed Doctor in the USA
              </h2>
              <ul className="text-[#fff] mt-3 2xl:text-[20px] md:text-[20px] leading-[116%] tracking-[-0.96px] font-medium md:py-[6px] pl-4 list-disc marker:text-[#1772ea]">
                <li className="pb-2">
                  Clinicals & Residency at Top U.S. Hospitals
                </li>
                <li>
                  Earn 2 Crores+ per year (~$250K+)
                  <br />
                  (10x salary with merely 50% fees of private Indian MBBS-MD)
                </li>
              </ul>
            </div>

            <div className="md:w-[42%] rounded-2xl z-[999] relative md:rounded-[24px] 2xl:text-[16px] xl:text-[14px] md:p-2 md:pb-10">
              <MbbsForm submitButtonName="Speak with an expert" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoctorBannerDesktop;
